/* eslint-disable no-unused-vars */
const devServer = 'https://api-dev.notysing.com';
const production = 'https://api.notysing.com';

export const API = production;
export const RESOURCES = 'https://dashboard.notysing.com/resources';
